import { useEffect, useRef, type FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { closeNewClient, useNewClientStore } from "../newClientStore";
import { NewClientDialog } from "./NewClientDialog";

/**
 * The app-wide New Client modal: `openNewClient()` opens it over the current
 * screen. Opening the new client (a route change) closes it.
 */
export const NewClientDialogHost: FC = () => {
  const { open, session } = useNewClientStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const openedAt = useRef<string | null>(null);

  useEffect(() => {
    if (!open) openedAt.current = null;
    else if (openedAt.current === null) openedAt.current = pathname;
    else if (pathname !== openedAt.current) closeNewClient();
  }, [open, pathname]);

  return (
    <NewClientDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) closeNewClient();
      }}
      onCreated={(uid) => navigate(`/clients/${uid}`)}
      session={session}
    />
  );
};
